import api from "./api";

const route = "/files";

const AdjuntosService = {
  getAdjunto: () => api.get(route),
  getFormData: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return formData;
  },
  postAdjunto: (formData) =>
    api.post(route, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
};

export default AdjuntosService;
